import {APICore} from "./apiCore";

const api = new APICore();


function chatrooms() {
    const baseUrl = "/supplier-api/chat/available-rooms";
    return api.get(`${baseUrl}`, {});
}

function awaitingOfferPackages() {
    const baseUrl = "/supplier-api/offers/awaiting-offer-packages";
    return api.get(`${baseUrl}`, {});
}

function chatroomDetail(chatroomId: string, cancelToken?: any) {
    const baseUrl = "/supplier-api/chat/" + chatroomId + "/details";
    return api.get(`${baseUrl}`, {}, cancelToken);
}

function chatroomMessageList(chatroomId: string, lastMessageId: any, count: any, cancelToken: any) {
    const baseUrl = "/supplier-api/chat/room/" + chatroomId;
    return api.get(`${baseUrl}`, {room_id: chatroomId, lastMessageId, count}, cancelToken);
}

function chatroom(chatroomId: string) {
    const baseUrl = "/supplier-api/messaging/chatroom/" + chatroomId;
    return api.get(`${baseUrl}`, {});
}

function getAgents(search: string, cancelToken?: any, perPage = 20, page = 1) {
    const baseUrl = "/supplier-api/agents";
    return api.get(`${baseUrl}`, {search, perPage, page}, cancelToken)
}

function getRoomId(type: string, user_id: number) {
    const baseUrl = "/supplier-api/chat/get-room-id";
    return api.create(`${baseUrl}`, {type, user_id})
}


function countries(params: any, cancelToken: any) {
    const baseUrl = "/supplier-api/countries";
    return api.get(`${baseUrl}`, params, cancelToken);
}


export {
    chatrooms,
    awaitingOfferPackages,
    chatroomDetail,
    chatroomMessageList,
    getRoomId,
    chatroom,
    countries,
    getAgents
};
